import React, { useState, useEffect, useContext } from "react";
import { Footer, Header, ImageAvatar, LocationSearch, InputTypePhone } from "../../components";
import "./styles.css";
import { Images } from "../../theme";
import { Link } from "react-router-dom";
import InputTextCustom from "../../components/InputTextCustom";
import { useTranslation } from "react-i18next";
import ResetPassword from "../Auth/ResetPassword";
import { Modal } from "react-responsive-modal";
import { AuthContext } from "../../context/AuthContext";

export default function EditProfile(props) {
  const userContextData = useContext(AuthContext);
  let {
    user_data,
    loginData,
    imageUrl,
    handle_user_profile,
    handle_profile_image,
    profileStatus,
  } = userContextData;
  const { t } = useTranslation();

  const [rowData, setRowData] = useState({});
  const [forgotModal, setForgotModal] = useState(false);
  const [locationModal, setLocationModal] = useState(false);
  const [locationvalue, setLocationvalue] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [profileImage, setProfileImage] = useState({
    imageData: "",
    ImageUrl: Images.profileImage,
  });

  const onCloseLocationModal = () => setLocationModal(false);
  const onCloseForgotModal = () => setForgotModal(false);

  useEffect(() => {
    user_data();
  }, []);

  useEffect(() => {
    setRowData(loginData);
    setLocationvalue(loginData.location);
    setProfileImage({
      imageData: "",
      ImageUrl: loginData.profileImagePath
        ? `${imageUrl}${loginData.profileImagePath}`
        : Images.profileImage,
    });
  }, [loginData]);

  function renderProfileImage(image) {
    setProfileImage(image);
    let formData = new FormData();
    formData.append("image", image.imageData);
    handle_profile_image(formData);
  }
  const onChangeInput = async (data) => {
    setFormErrors(false);
    const { selectedInput } = data;
    let upData = { ...rowData };
    upData[selectedInput] = data.value;
    data.state(upData);
  };

  function renderLocaton(value) {
    setRowData({ ...rowData, longitude: value.lng, latitude: value.lat });
  }

  function checkValidation() {
    let { firstname, lastname, longitude, latitude, description, phone } =
      rowData;
    if (!firstname) {
      setFormErrors({
        ...formErrors,
        firstnameError: t("First_Name"),
      });
    } else if (!lastname) {
      setFormErrors({
        ...formErrors,
        lastnameError: t("Last_Name"),
      });
    } else if (!locationvalue) {
      setFormErrors({
        ...formErrors,
        locationError: t("Location_Required"),
      });
    } else if (!description) {
      setFormErrors({
        ...formErrors,
        descriptionError: t("Description_Required"),
      });
    } else {
      let payload = {
        firstname,
        lastname,
        location: locationvalue,
        longitude,
        latitude,
        description,
      };
      // phone && payload.phone == phone;
      handle_user_profile(payload);
    }
  }

  return (
    <>
      <Header />
      <div className="container">
        <div className="row mt-4">
          <div className="col-md-3">
            <h1 className="withDrawHeading">{t("Profile_Details")}</h1>
          </div>
          <div className="col-md-9 col-12 btnResetEditProfile">
            <button
              class="btn-custom btn-light BtneditProfile"
              onClick={checkValidation}
            >
              {t("Save")}
            </button>
            <Link
              className="signup-link"
              onClick={() => setForgotModal(true)}
              to=""
            >
              <button class="btn-custom btn-light resetEditBtn">
                {t("Reset_Password")}
              </button>
            </Link>
          </div>
        </div>
        <div className="row mt-3 mb-5">
          <div className="col-md-3 mt-4">
            <div className="row" style={{ justifyContent: "center" }}>
              <div className="col-md-auto">
                <div>
                  <ImageAvatar
                    imageData={renderProfileImage}
                    source={profileImage && profileImage.ImageUrl}
                  />
                  <h1 className="profileName">
                    {rowData.firstname} {rowData.lastname}
                  </h1>
                  <p className="profileEmail">{rowData.email}</p>
                </div>
              </div>
            </div>
            <h1 className="statistics">{t("Statistics")}</h1>
            <Link to="/WithDraw">
              <div className="statisticsCard">
                <h1 className="statisticsPrice">
                  ${profileStatus?.earning ? profileStatus?.earning : 0}
                </h1>
                <div>
                  <span className="statisticsLifetime">
                    {t("Lifetime_Earnings")}
                  </span>
                  <img
                    className="statisticsImg"
                    src={Images.statistics}
                    alt="image"
                  />
                </div>
              </div>
            </Link>
            <div className="row m-0" style={{ width: "100%" }}>
              <div className="col-md-6 col-6 p-0 paddingRightCard">
                <div className="CardStatic">
                  <span className="countStatic">
                    {profileStatus?.rents ? profileStatus?.rents : 0}
                  </span>
                  <br />
                  <span className="textStatic">{t("Rentals")}</span>
                </div>
              </div>
              <div className="col-md-6 col-6 p-0 paddingLeftCard">
                <div className="CardStatic">
                  <span className="countStatic">
                    {profileStatus?.days ? profileStatus?.days : 0}
                  </span>
                  <br />
                  <span className="textStatic">{t("Days_With_Us")}</span>
                </div>
              </div>
            </div>

            <div className="row m-0" style={{ width: "100%" }}>
              <div className="col-md-6 col-6 p-0 paddingRightCard">
                <div className="CardStatic">
                  <span className="countStatic">
                    {profileStatus?.lends ? profileStatus?.lends : 0}
                  </span>
                  <br />
                  <span className="textStatic">{t("Lends")}</span>
                </div>
              </div>
              <div className="col-md-6 col-6 p-0 paddingLeftCard">
                <div className="CardStatic">
                  <span className="countStatic">0</span>
                  <br />
                  <span className="textStatic">{t("Messages")}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-9">
            <div className="cardProfile">
              <div className="row">
                <div className="col-md-6 col-6">
                  <InputTextCustom
                    headingLabel={t("First_Name")}
                    value={rowData.firstname}
                    placeholder={t("First_Name")}
                    errorState={formErrors.firstnameError}
                    onChange={(e) => {
                      onChangeInput({
                        value: e.target.value,
                        state: setRowData,
                        selectedInput: "firstname",
                        selectedRow: rowData,
                      });
                    }}
                  />
                </div>
                <div className="col-md-6 col-6">
                  <InputTextCustom
                    headingLabel={t("Last_Name")}
                    value={rowData.lastname}
                    placeholder={t("Last_Name")}
                    errorState={formErrors.lastnameError}
                    onChange={(e) => {
                      onChangeInput({
                        value: e.target.value,
                        state: setRowData,
                        selectedInput: "lastname",
                        selectedRow: rowData,
                      });
                    }}
                  />
                </div>

                <div className="col-md-6">
                  <InputTextCustom
                    headingLabel={t("Email")}
                    value={rowData.email}
                    disabled={true}
                    placeholder={t("Email")}
                  />
                </div>
                <div className="col-md-6">
                  <InputTypePhone
                    headingLabel={t("Phone_Number")}
                    placeholder={t("Phone_Number")}
                    value={rowData.phone}
                    onChange={(e) => {
                      loginData?.phone_verified_at
                        ? onChangeInput({
                            value: e.target.value,
                            state: setRowData,
                            selectedInput: "phone",
                            selectedRow: rowData,
                          })
                        : alert(t("phone_not_set"));
                    }}
                  />
                </div>
                <div className="col-md-12 col-12">
                  <Link to="" onClick={() => setLocationModal(true)}>
                    <button className="btn location-btn">
                      {locationvalue ? locationvalue : t("Not_Set")}
                    </button>
                  </Link>
                  <div style={{ color: "red", fontSize: 12 }}>
                    {formErrors.locationError}
                  </div>
                </div>

                <div className="col-md-12 col-12">
                  <label class="control-label customStyleLabel">
                    {t("Describe_Yourself")}
                  </label>
                  <div>
                    <textarea
                      id="w3review"
                      name="w3review"
                      rows="4"
                      value={rowData.description}
                      className="form-control textAreaStyle"
                      placeholder={t("Describe_Your_self_Description")}
                      onChange={(e) => {
                        onChangeInput({
                          value: e.target.value,
                          state: setRowData,
                          selectedInput: "description",
                          selectedRow: rowData,
                        });
                      }}
                    ></textarea>
                  </div>
                  <div style={{ color: "red", fontSize: 12 }}>
                    {formErrors.descriptionError}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <Modal open={forgotModal} onClose={onCloseForgotModal} center>
        <ResetPassword onClose={onCloseForgotModal} {...props} />
      </Modal>
      <Modal
        classNames={{
          modal: "locationModal",
        }}
        open={locationModal}
        onClose={onCloseLocationModal}
        center
      >
        <LocationSearch
          locationLatLng={renderLocaton}
          locationData={setLocationvalue}
          value={locationvalue}
        />
      </Modal>
    </>
  );
}
